import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from '@services/interceptors/auth-interceptor';
import { CompanyLocaleInterceptor } from '@services/interceptors/company-locale.interceptor';
import { ErrorHandlerInterceptorInterceptor } from '@services/interceptors/error-handler-interceptor/error-handler-interceptor.interceptor';
import { HttpCancelInterceptor } from '@services/interceptors/http-cancel-interceptor';
import { HttpsConverterInterceptor } from '@services/interceptors/https-converter-interceptor.service';
import { UserLanguageInterceptor } from '@services/interceptors/user-language.interceptor';

export const HTTP_INTERCEPTOR_PROVIDERS = [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: CompanyLocaleInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: UserLanguageInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpCancelInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpsConverterInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlerInterceptorInterceptor, multi: true },
];
